import { CustomSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/types';
import { createImageSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/carouselSlide.util';

export const RoseSetItems: CustomSlide[] = [
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/1%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/2%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/3%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/4%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/5%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/6%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/7%401x.jpg'
    ),
];
